/**
 * The partner shown on the website, and who answers privacy questions.
 *
 * Empty values hide what depends on them: no logo shows the name as text, no
 * address shows no button, no Information Officer address says "ask in the
 * app". Fill them in here once the details are confirmed — nothing else changes.
 */
import sum1Logo from "@/assets/stokkie/sum1-logo.webp";

export const PARTNER: {
  name: string;
  /** An imported image. Sum1's is white on transparent, so it sits on a dark tile. */
  logo: string | null;
  url: string | null;
  informationOfficer: string | null;
} = {
  name: "Sum1 Investments",
  logo: sum1Logo,
  url: "https://sum1investments.co.za/",
  informationOfficer: null,
};
